import { Button, Drawer, Fab, Grid, makeStyles, Typography } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { defer } from '@thalesrc/js-utils';
import React, { useCallback, useContext, useRef } from 'react';

import AutoComplete from 'Common/Form/AutoComplete';
import Form, { FormRef } from 'Common/Form/Form';
import Select from 'Common/Form/Select';
import TextField from 'Common/Form/TextField';
import { HSTableContext } from 'Common/Table/HSTable/hs-table.context';
import Toolbar from 'Common/Toolbar';
import { SelectOptionsContext } from 'context/select-options.context';
import { useAsyncEffect, useDialogState } from 'utils';

import DateInput from '../../../../Common/Form/DateInput';

const useStyles = makeStyles(() => ({
  fab: {
    transform: 'translateY(50%)',
  },
  drawer: {
    maxWidth: 320,
  },
}));

export default function Filters() {
  const classes = useStyles();
  const { open, close, opened } = useDialogState();
  const { setExtraArgs, extraArgs } = useContext(HSTableContext);
  const { trainings, companies, departments, trainers, trainingDefinitions, positions, periodOfValidity } = useContext(
    SelectOptionsContext
  );
  const formRef = useRef<FormRef<Record<string, any>>>();

  const submit = useCallback(
    values => {
      setExtraArgs({ filters: values });
      close();
    },
    [setExtraArgs, close]
  );

  const clear = useCallback(() => {
    setExtraArgs({ filters: {} });
    close();
  }, [setExtraArgs, close]);

  useAsyncEffect(async () => {
    if (!extraArgs.filters || !opened) {
      return;
    }

    await defer();

    for (const [key, value] of Object.entries(extraArgs.filters)) {
      formRef.current.methods.setValue(key, value);
    }

    formRef.current.methods.trigger();
  }, [extraArgs, opened]);

  return (
    <>
      <Fab
        onClick={open}
        size="small"
        className={classes.fab}
        style={{
          backgroundColor: `${
            Object.keys(extraArgs)?.length > 0 ? (Object.keys(extraArgs?.filters)?.length > 0 ? '#f50057' : '#2196f3') : '#2196f3'
          }`,
          color: 'white',
        }}>
        <FilterListIcon />
      </Fab>
      <Drawer anchor="left" open={opened} onClose={close} classes={{ paper: classes.drawer }}>
        <Toolbar color="secondary" className="mb-2">
          <Typography variant="h6">Eğitim Filtreleme</Typography>
        </Toolbar>
        <Form onSubmit={submit} ref={formRef}>
          <Grid container className="p-2">
            <Grid item xs={12}>
              <Typography variant="button" display="block" gutterBottom>
                Eğitim Tarihi
              </Typography>
            </Grid>
            <Grid className="pr-1" item xs={6}>
              <DateInput type="date" name="startDate" label="En Az" />
            </Grid>
            <Grid className="pr-1" item xs={6}>
              <DateInput type="date" name="endDate" label="En Çok" />
            </Grid>
            <Grid item xs={12}>
              <Typography style={{ marginTop: '15px' }} variant="button" display="block" gutterBottom>
                Eğitim Süresi (dk)
              </Typography>
            </Grid>
            <Grid item xs={6} className="pr-1">
              <TextField type="number" name="minDuration" label="En Az" />
            </Grid>
            <Grid item xs={6} className="pl-1">
              <TextField type="number" name="maxDuration" label="En Çok" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="trainingIds" options={trainings} label="Eğitimler" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="companyIds" options={companies} label="Şirketler" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="departmentDefinitionIds" options={departments} label="Departmanlar" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="positionDefinitionIds" options={positions} label="Pozisyonlar" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="trainerIds" options={trainers} label="Eğitmenler" />
            </Grid>
            <Grid item xs={12}>
              <AutoComplete name="trainingDefinitionIds" options={trainingDefinitions} label="Konular" />
            </Grid>
            <Grid item xs={12} md={12} lg={12} sm={12}>
              <Select name="isArchived" options={periodOfValidity} label="Geçerlilik Süresi " />
            </Grid>
          </Grid>
          <footer className="px-2 flex-justify">
            <Button className="mr-1" fullWidth type="button" variant="contained" onClick={clear}>
              Temizle
            </Button>
            <Button fullWidth type="submit" variant="contained" color="secondary">
              Filtrele
            </Button>
          </footer>
        </Form>
      </Drawer>
    </>
  );
}
